var React = require('react');

function BellInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.65333 14C9.53613 14.2021 9.3679 14.3698 9.16548 14.4864C8.96307 14.603 8.73359 14.6643 8.5 14.6643C8.26641 14.6643 8.03693 14.603 7.83452 14.4864C7.63211 14.3698 7.46387 14.2021 7.34667 14M12.5 5.33337C12.5 4.27251 12.0786 3.25509 11.3284 2.50495C10.5783 1.7548 9.56087 1.33337 8.5 1.33337C7.43913 1.33337 6.42172 1.7548 5.67157 2.50495C4.92143 3.25509 4.5 4.27251 4.5 5.33337C4.5 10 2.5 11.3334 2.5 11.3334H14.5C14.5 11.3334 12.5 10 12.5 5.33337Z","stroke":"#08273A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BellInline.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = BellInline;

BellInline.default = BellInline;
